import ApiSearch from "../models/ApiSearch";

/** Egy ApiSearchPage példány navigáció után visszatölthető állapota. */
export interface ApiSearchPageState {
  apiSearch: ApiSearch;
  /** A multiselect oszlopok kijelölései (v-model map a filteren kívül él) */
  multiSelectSelectedOptions: any;
}

/**
 * Modul-szintű állapottár a `persistFilters` prop-pal jelölt ApiSearchPage-ekhez.
 * A Layout `<router-view :key="$route.fullPath">`-je miatt a komponens minden
 * navigációnál újra létrejön — az ide elmentett állapot (szűrők, keresés,
 * rendezés) így túléli a route-váltást, teljes újratöltésnél (F5) viszont
 * tiszta lappal indul. Kulcs: `name|url`.
 */
const states = new Map<string, ApiSearchPageState>();

export function saveApiSearchState(key: string, state: ApiSearchPageState): void {
  states.set(key, state);
}

export function getApiSearchState(key: string): ApiSearchPageState | undefined {
  return states.get(key);
}
